import { useQuery } from 'urql';
import { getMetaAdAccountsOnly } from '../graphql';
import type { AccountsOnlyData } from './types';

export const useAccountsOnly = ({ clientId, pause = false }: { clientId: string; pause?: boolean }) => {
  const [{ data, fetching, error }] = useQuery<AccountsOnlyData>({
    query: getMetaAdAccountsOnly,
    variables: { clientId },
    pause: pause || !clientId,
  });

  return {
    data,
    fetching,
    error,
    accounts: data?.client?.metaAdAccounts?.filter((account) => account?.id) || [],
    instagramAccounts: data?.client?.instagramAccounts?.filter((account) => account?.accountId) || [],
  };
};
